import {Poi} from '../../../react-app-env';
import React from 'react';
import SidebarHeader, {buildPopStackButton} from '../../sidebar/SidebarHeader';
import {SidebarPage} from '../../sidebar/SidebarPage';
import {StackApi} from '../../stack/Stack.types';
import ListViewGroup from '../../listview/listviewgroup/ListViewGroup';
import ListView from '../../listview/ListView';
import {i18n} from '../../../i18n/i18n';
import ListViewItem from '../../listview/listviewitem/ListViewItem';
import SidebarScrollableContent from '../../sidebar/SidebarScrollableContent';
import {PoiMetaData} from '../../../services/MetaDataService';

export interface OpeningHoursSidebarPageProps {
  readonly poi: Poi;
  readonly metaData?: PoiMetaData;
  readonly stackApi: StackApi;
}

function OpeningHoursSidebarPage({ poi, metaData, stackApi }: OpeningHoursSidebarPageProps) {

  const label = metaData?.openingHours.openNow
      ? i18n().poiDetails.schedule.currentlyOpen
      : i18n().poiDetails.schedule.currentlyClosed;

  return <SidebarPage className="opening-hours">
    <SidebarHeader
        title={i18n().poiDetails.openingHours.title}
        subtitle={poi.title}
        buttons={[
          buildPopStackButton(() => stackApi.pop())
        ]}/>
    <SidebarScrollableContent>
      <ListView>
        <ListViewGroup>
          <ListViewItem title={label}
                        iconCategory={'fa-clock fa-regular'}/>
        </ListViewGroup>
        <ListViewGroup>
          {metaData?.openingHours.details?.map(detail => {
            return <ListViewItem key={detail}
                                 title={detail}/>;
          })}
        </ListViewGroup>
      </ListView>
    </SidebarScrollableContent>
  </SidebarPage>;
}

export default OpeningHoursSidebarPage;
